import { CordovaService } from './cordova.service';


export const CordovaInjectables: Array<any> = [
  {provide: CordovaService, useClass: CordovaService},
];
